'use strict'

class CookiePolicy {
	static SELECTOR_CLASS_CONTAINER = '.cookies__container'
	static SELECTOR_CLASS_DISMISS_BUTTON = '.cookies__accept--button__dismiss'
	static PROP_STORAGE_KEY = 'cookies'
	static PROP_STORAGE_VALUE = 'true'
	static PROP_DISPLAY_BLOCK = 'block'

	init() {
		const container = document.querySelector( CookiePolicy.SELECTOR_CLASS_CONTAINER )
		if ( !container ) {
			return
		}

		if ( localStorage.getItem( CookiePolicy.PROP_STORAGE_KEY ) === CookiePolicy.PROP_STORAGE_VALUE ) {
			container.remove()
		} else {
			container.style.display = CookiePolicy.PROP_DISPLAY_BLOCK
		}

		const dismissButton = document.querySelector( CookiePolicy.SELECTOR_CLASS_DISMISS_BUTTON )
		if ( dismissButton ) {
			dismissButton.addEventListener( 'click', () => {
				this.handleDismiss()
			} )
		}
	}

	handleDismiss() {
		localStorage.setItem( CookiePolicy.PROP_STORAGE_KEY, CookiePolicy.PROP_STORAGE_VALUE )
		const container = document.querySelector( CookiePolicy.SELECTOR_CLASS_CONTAINER )
		if ( container ) {
			container.remove()
		}
	}
}

export default function init() {
	new CookiePolicy().init()
}
